import * as React from 'react';
import * as ReactDOM from 'react-dom';
import StrataRootComponent from './strata-root-component';


ReactDOM.render(
    <StrataRootComponent />
, document.getElementById('root'));


if (module["hot"]) {
    module["hot"].accept()
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/strata/index.tsx